import {
  useArtifactsPanelActions,
  useArtifactsPanelReturnFocusRef,
  useArtifactsPanelState,
} from './ArtifactsPanelContext'
import {ArtifactsPanelShell} from './ArtifactsPanelShell'

export function ArtifactsPanel() {
  const {activeArtifactId, activeArtifact, tabs} = useArtifactsPanelState()
  const {activate, closePanel, promoteOverflow, closeTab} = useArtifactsPanelActions()
  const returnFocusRef = useArtifactsPanelReturnFocusRef()

  return (
    <ArtifactsPanelShell
      open={activeArtifactId !== null}
      onClose={closePanel}
      tabs={tabs}
      activeId={activeArtifactId}
      activeArtifact={activeArtifact}
      onActivate={activate}
      onPromoteOverflowTab={promoteOverflow}
      onCloseTab={closeTab}
      returnFocusRef={returnFocusRef}
    />
  )
}
